import {common_utils} from "../common/common_utils";
import {slots_tool} from "./slots_tool";

function game_5012()
{

}

game_5012.odd_map  = {

  "P7":[0,0,15,150,1000],
  "P6":[0,0,15,100,500],
  "P5":[0,0,10,50,200],
  "P4":[0,0,10,30,120],
  "P3":[0,0,5,15,75],
  "P2":[0,0,5,10,30],
  "P1":[0,0,5,10,30],
};
game_5012.mul_array  = [

];

game_5012.mul = 15

game_5012.readDataValue = function(this1,data)
{
  this1.hasextra = false
  this1.hasfree = true
  this1.hasbonuswin = false
  this1.mapList = []

  var rows = 3
  this1.isfree = common_utils.isFreeTip(data)
  common_utils.readDataValue(this1,data);
  var mapJson = JSON.parse(data.detail.mapData)
  this1.scatterwin = data.detail.winFreeGameTimes
  this1.bonuswin = mapJson.bonusWin

  this1.mapIndex = []
  for(var key = 0; key < mapJson.maps.length; key++)
  {
    var mapTmp = []
    for (var j = 0; j < rows; j++) {
      for (var i = 0; i < 5; i++) {
        mapTmp.push(mapJson.maps[key].map[i][j])
      }
    }
    this1.mapList.push(mapTmp)
    var winListDic = {}
    var mapIndexTmp = []
    let winValueList = [];
    for (var index = 0; index < mapJson.maps[key].winlist.length; index++)
    {
      var line = true;
      let win_data = mapJson.maps[key].winlist[index]
      for(var subIndex = 0; subIndex < 5; subIndex++)
      {
        var showindex = win_data.l[subIndex] * 5 + subIndex;
        var item = mapTmp[showindex];

        if ((item != mapJson.maps[key].winlist[index].s) && (item != "W"))
        {
          line = false
        }
        if (line)
        {
          mapIndexTmp.push(showindex)
        }
      }
      slots_tool.read_win_data(winListDic,win_data)
    }
    slots_tool.setWinValue(winValueList,winListDic,game_5012.odd_map,0);
    this1.mapIndex.push(mapIndexTmp)
    this1.mapListDetail.push(winListDic)
  }

  let winValueList = [];
  slots_tool.setWinValue(winValueList,this1.mapListDetail,game_5012.odd_map,0);
  this1.winValueTotal = slots_tool.TotalValueByData(winValueList,data,game_5012.mul,this1.extra,0,this1.bonuswin)

  this1.$nextTick(() => {
    this1.$nextTick(() => {
      this1.$nextTick(() => {
        this1.clearLines();
        setTimeout(() => {
          this1.clearLines();
          for(let key = 0; key < mapJson.maps.length; key++) {
            for (let index = 0; index < mapJson.maps[key].winlist.length; index++) {
              for(let subIndex = 0; subIndex < 4; subIndex++) {
                let fromIndex = mapJson.maps[key].winlist[index].l[subIndex] * 5 + subIndex;
                let toIndex = mapJson.maps[key].winlist[index].l[subIndex + 1] * 5 + subIndex + 1;
                slots_tool.drawLines(slots_tool.setMapsLineIdName("s",key,fromIndex), slots_tool.setMapsLineIdName("s",key,toIndex), index)
                //this1.drawLines("m_" + key + "_" + fromindex, "m_" + key + "_" + toindex, index)
              }
            }
          }
        }, 1000);
      })
    })
  })

}
export {
  game_5012
};




// WEBPACK FOOTER //
// ./src/components/slots/game_5012.js